import { render, staticRenderFns } from "./ServiceSwiper.vue?vue&type=template&id=cdbfda66&scoped=true"
import script from "./ServiceSwiper.vue?vue&type=script&lang=js"
export * from "./ServiceSwiper.vue?vue&type=script&lang=js"
import style0 from "./ServiceSwiper.vue?vue&type=style&index=0&id=cdbfda66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbfda66",
  null
  
)

export default component.exports